import BaseModel from "../BaseModel";

export default class InvoiceItem extends BaseModel{
    static entity = 'invoiceItems';
    static primaryKey = "uuid";
    static fields(){
        return {
            uuid: this.attr(null),
            invoice_uuid: this.attr(null),
            service: this.attr(null),
            quantity: this.attr(null),
            rate: this.attr(null),
            total: this.attr(null),
            description: this.attr(null),
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static route(){
        return '/invoices/items'
    }
}
